<template>
  <div v-loading="loading">
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="userNameSearch">
        <div class="searchTxt">用户名称：</div>
        <el-input
          placeholder="请输入用户名称"
          size="medium"
          v-model="queryUser.userName"
          @change="getUser()"
          clearable
        >
        </el-input>
      </div>
    </div>

    <!-- 卡片框 -->
    <div class="bottom-bigbox">
      <!-- 左边单位卡片区域 -->
      <div class="leftBox">
        <!-- 单位树 -->
        <el-tree
          class="treeBox"
          :data="depTrees"
          :props="defaultTreesProps"
          default-expand-all
          :expand-on-click-node="false"
          :highlight-current="true"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </div>
      <!-- 右边用户卡片区域 -->
      <el-col :span="20">
        <el-card class="right-card">
          <!-- 增加用户按钮 -->
          <el-button
            icon="el-icon-plus"
            type="primary"
            size="small"
            class="add-btn"
            plain
            @click="AddUserDialogVisible = true"
          >
            新增
          </el-button>
          <!-- 用户信息表格区域 -->
          <el-table
            :data="userList"
            :header-cell-style="{
              background: '#0395d9',
              color: '#505255',
              textAlign: 'center',
            }"
            :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
          >
            <el-table-column prop="userName" label="用户名称">
            </el-table-column>
            <el-table-column prop="roleName" label="所属角色">
            </el-table-column>
            <el-table-column prop="depName" label="所属项目"> </el-table-column>
            <el-table-column label="操作" width="130">
              <template v-slot="slot">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="bottom-start"
                >
                  <el-button
                    type="warning"
                    size="small"
                    circle
                    icon="el-icon-edit"
                    @click="OpenUpdateUserDialog(slot.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="删除"
                  placement="bottom-start"
                  effect="dark"
                >
                  <el-button
                    type="danger"
                    size="small"
                    circle
                    icon="el-icon-delete"
                    @click="deleteUser(slot.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryUser.page"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="queryUser.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </el-card>
     </el-col>
    </div>

    <!-- 添加用户信息对话框 -->
    <el-dialog
      title="新增用户"
      :visible.sync="AddUserDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearAddUserDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="addUserFormRef"
        :rules="AddUserRules"
        :model="AddUserInfo"
        label-width="80px"
      >
        <el-form-item prop="userName" label="用户名称">
          <el-input
            placeholder="请输入用户名称"
            v-model="AddUserInfo.userName"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="userPassword" label="密码">
          <el-input
            placeholder="请输入密码"
            v-model="AddUserInfo.userPassword"
            clearable
            type="password"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="checkPassword" label="确认密码">
          <el-input
            placeholder="请输入确认密码"
            v-model="AddUserInfo.checkPassword"
            clearable
            type="password"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="userDepId" label="所属项目">
          <el-select
            v-model="AddUserInfo.userDepId"
            placeholder="请选择"
            ref="MySelect"
          >
            <el-option
              :key="AddUserInfo.userDepId"
              :label="checkDname"
              :value="AddUserInfo.userDepId"
              style="height: auto"
            >
            </el-option>
            <el-tree
              style="height: 300px"
              :data="depTrees"
              :props="defaultTreesProps"
              :expand-on-click-node="false"
              :highlight-current="true"
              @node-click="handleNodeClick2"
            >
            </el-tree>
          </el-select>
        </el-form-item>
        <el-form-item prop="userRoleId" label="所属角色">
          <el-select
            v-model="AddUserInfo.userRoleId"
            filterable
            clearable
            placeholder="请选择角色"
            @click.native="getRole()"
          >
            <el-option
              v-for="item in roleList"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddUser()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改用户信息对话框 -->
    <el-dialog
      title="修改用户信息"
      :visible.sync="UpdateUserDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearAddUserDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="addUserFormRef"
        :rules="UpdateUserRules"
        :model="UpdateUserInfo"
        label-width="80px"
      >
        <el-form-item prop="userName" label="用户名称">
          <el-input
            placeholder="请输入用户名称"
            v-model="UpdateUserInfo.userName"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="userDepId" label="所属项目">
          <el-select
            v-model="UpdateUserInfo.userDepId"
            placeholder="请选择"
            ref="MySelect"
          >
            <el-option
              :key="UpdateUserInfo.userDepId"
              :label="checkUserDep"
              :value="UpdateUserInfo.userDepId"
              style="height: auto"
            >
            </el-option>
            <el-tree
              style="height: 300px"
              :data="depTrees"
              :props="defaultTreesProps"
              :expand-on-click-node="false"
              :highlight-current="true"
              @node-click="handleNodeClick3"
            >
            </el-tree>
          </el-select>
        </el-form-item>
        <el-form-item prop="userRoleId" label="所属角色">
          <el-select
            v-model="UpdateUserInfo.roleName"
            clearable
            placeholder="请选择角色"
            filterable
            @click.native="getRole()"
            @change="checkRole(UpdateUserInfo.roleName)"
          >
            <el-option
              v-for="item in roleList"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId"
            >
              <!-- {{ item.roleName }} -->
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="userPassword" label="密码">
          <el-input
            placeholder="请输入密码"
            v-model="UpdateUserInfo.userPassword"
            clearable
            type="password"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="checkPassword" label="确认密码">
          <el-input
            placeholder="请输入确认密码"
            v-model="UpdateUserInfo.checkPassword"
            clearable
            type="password"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdateUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="UpdateUser()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    //密码验证规则
    var validatePass = (AddUserRules, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.AddUserInfo.checkPassword !== "") {
          this.$refs.addUserFormRef.validateField("checkPassword");
        }
        callback();
      }
    };
    var validatePass2 = (AddUserRules, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.AddUserInfo.userPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatePass3 = (AddUserRules, value, callback) => {
      if (value !== this.UpdateUserInfo.userPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      // 用户信息
      userList: [],
      // 条件查询用户信息
      queryUser: {
        // 用户名称
        userName: "",
        // 单位节点ID
        depId: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10,
      },
      // 总数
      total: 0,
      // 单位树信息
      depTrees: [],
      defaultTreesProps: {
        children: "depChilds",
        label: "depName",
      },
      // 控制添加用户对话框的显示和隐藏
      AddUserDialogVisible: false,
      loading: true,
      // 添加用户信息
      AddUserInfo: {
        // 用户名称
        userName: "",
        // 用户密码
        userPassword: "",
        checkPassword: "",
        // 所属单位ID
        userDepId: "",
        // 所属角色ID
        userRoleId: "",
      },
      // 查询权限信息
      queryRole: {
        // 角色名称
        roleName: "",
      },
      checkDname: "",
      // 权限信息
      roleList: "",

      // 控制修改用户对话框的显示和隐藏
      UpdateUserDialogVisible: false,

      // 修改用户信息
      UpdateUserInfo: {
        // 用户名称
        userName: "",
        // 用户密码
        userPassword: "",
        checkPassword: "",
        // 所属单位ID
        userDepId: "",
        // 所属角色ID
        userRoleId: "",
        // departmentName: "",
        userId: "",
        roleName: "",
      },
      checkUserDep: "",
      // departmentName: "",
      // 添加用户验证规则
      AddUserRules: {
        userName: [
          { required: true, message: "用户名必须填写", trigger: "blur" },
        ],
        userPassword: [
          {
            validator: validatePass,
            required: true,
            message: "密码必须填写",
            trigger: "blur",
          },
        ],
        checkPassword: [
          { validator: validatePass2, required: true, trigger: "blur" },
        ],
        userDepId: [
          { required: true, message: "项目必须选择", trigger: "change" },
        ],
        userRoleId: [
          { required: true, message: "角色必须选择", trigger: "change" },
        ],
      },

      // 修改用户验证规则
      UpdateUserRules: {
        userName: [
          { required: true, message: "用户名必须填写", trigger: "blur" },
        ],
        checkPassword: [{ validator: validatePass3, trigger: "blur" }],
        userDepId: [
          { required: true, message: "项目必须选择", trigger: "change" },
        ],
        userRoleId: [
          { required: true, message: "角色必须选择", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    this.getUser();
    this.GetAllDepTrees();
    // this.getRole();
  },
  methods: {
    // 获取用户信息
    async getUser() {
      const { data: res } = await this.$axios.get(`${this.$api}/user/search`, {
        params: this.queryUser,
      });
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.loading = false;
      this.userList = res.data.rows;
      this.total = res.data.total;
    },
    // 获取全部单位树
    async GetAllDepTrees() {
      const { data: res } = await this.$axios.get(`${this.$api}/department/getDepTree`);
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.depTrees = res.data;
    },
    handleNodeClick(data) {
      this.queryUser.depId = data.depId;
      this.getUser();
    },
    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryUser.pageSize = size;
      this.getUser();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryUser.page = current;
      this.getUser();
    },

    // 当选中单位时触发
    handleNodeClick2(data) {
      this.AddUserInfo.userDepId = data.depId;
      this.checkDname = data.depName;
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      this.$refs.MySelect.handleClose();
    },

    // 获取权限信息  (因为后端没有查询所有角色，所有分页默认显示1000条，超出1000条后面的就查不到)
    async getRole() {
      const { data: res } = await this.$axios.get(`${this.$api}/role/search`, {
        params: this.queryRole,
      });

      this.roleList = res.data.rows;
    },
    // 添加用户信息
    async AddUser() {
      this.$refs.addUserFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.post(`${this.$api}/user/add`, {
          userName: this.AddUserInfo.userName,
          userPassword: this.AddUserInfo.userPassword,
          userDepId: this.AddUserInfo.userDepId,
          userRoleId: this.AddUserInfo.userRoleId,
        });
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("添加用户成功");
        this.AddUserDialogVisible = false;
        this.getUser();
      });
    },
    //关闭增加用户信息对话框触发
    clearAddUserDialogVisible() {
      this.$refs.addUserFormRef.resetFields();
      this.checkDname = "";
    },

    // 打开修改用户对话框
    OpenUpdateUserDialog(data) {
      this.UpdateUserDialogVisible = true;
      this.UpdateUserInfo.userName = data.userName;
      this.UpdateUserInfo.roleName = data.roleName;
      this.checkUserDep = data.depName;
      this.UpdateUserInfo.userId = data.userId;
      this.UpdateUserInfo.userRoleId = data.userRoleId;
      this.UpdateUserInfo.userDepId = data.userDepId;
    },

    // 当修改用户选中单位时触发
    handleNodeClick3(data) {
      this.UpdateUserInfo.userDepId = data.depId;
      this.checkUserDep = data.depName;
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      this.$refs.MySelect.handleClose();
    },

    // 当修改用户选中角色时触发
    checkRole(data) {
      this.UpdateUserInfo.userRoleId = data;
    },
    // 修改用户信息
    UpdateUser() {
      this.$refs.addUserFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.put(
          `${this.$api}/user/modify/${this.UpdateUserInfo.userId}`,
          {
            userName: this.UpdateUserInfo.userName,
            userPassword: this.UpdateUserInfo.userPassword,
            userDepId: this.UpdateUserInfo.userDepId,
            userRoleId: this.UpdateUserInfo.userRoleId,
          }
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.UpdateUserDialogVisible = false;
        this.$message.success("修改用户信息成功");
        this.getUser();
      });
    },

    // 删除用户信息
    async deleteUser(value) {
      const confirmVal = await this.$confirm(
        "此操作将永久删除该用户, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.delete(
        `${this.$api}/user/delete/${value.userId}`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }

      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryUser.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryUser.page === lastPage &&
        this.total % this.queryUser.pageSize === 1
      ) {
        this.queryUser.page--; //页码-1
      }

      this.$message.success("已成功删除该用户");
      this.getUser();
    },
  },
};
</script>

<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}

/* 搜索区域 */
.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;

  // 用户名搜索区域
  .userNameSearch {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 30px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 150px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}
/*下面内容区域大盒子*/
.bottom-bigbox {
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

/* 左边单位列表 */
.leftBox {
  width: 300px;
  height: calc(100vh - 159px);
  /* background-color: #001114; */
  background-image: url(../../../assets/img/dataBoard/box2.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  opacity: 0.8;
  /* position: absolute; */
  /* left: 0; */
  display: flex;
  z-index: 999;
}

/* 组织架构信息列表区域 */
.treeBox {
  width: 300px;
  margin: 40px 10px 20px 10px;
  height: calc(100vh - 220px) !important;
  overflow-y: auto !important;
  overflow-x: auto !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/SystemManagement/userManagement.vue